import { render, staticRenderFns } from "./InlineObjectRenderer.vue?vue&type=template&id=b5e8fb24&"
import script from "./InlineObjectRenderer.vue?vue&type=script&lang=js&"
export * from "./InlineObjectRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports